/* src/app/shared/authentication/components/login-selection/login-selection.component.scss */
:root {
  --color1: #2172cd;
  --color2: #2e3d4c;
  --color3: #5bc7aa;
  --color4: #8f76e5;
  --color5: #f5cf50;
  --color6: #18a957;
  --color7: #f48f33;
  --color8: #df1642;
  --color9: #37baf6;
  --color10: #667c95;
}
.auth .login-form .small-desc {
  padding-bottom: 0;
}
.auth .login-form .desc {
  padding: 0 10px 20px;
}
.login-button {
  align-items: unset;
}
@media (max-width: 768px) {
  .login-button > div {
    padding-top: 20px;
  }
}
.login-button > div:first-child {
  border-right: 1px solid #bdbdbd;
}
@media (max-width: 768px) {
  .login-button > div:first-child {
    border-right: none;
    border-bottom: 1px solid #bdbdbd;
    padding-bottom: 20px;
    padding-top: 0;
  }
}
.social-buttons {
  display: flex;
  justify-content: center;
}
a.simple-btn.simple-btn-ricon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  min-height: 54px;
  border-radius: 50%;
  padding: 0;
  margin: 0 5px;
  background: #e0e0e0;
}
a.simple-btn.simple-btn-ricon:hover {
  background: var(--primaryColor);
}
a.simple-btn.simple-btn-ricon i[class*=icon-social-] {
  background: #fff;
  border-radius: 50%;
  margin: 0;
}
a.simple-btn.simple-btn-ricon i[class*=icon-social-]:after {
  background: none;
}
a.simple-btn.simple-btn-ricon i[class*=icon-social-] img {
  width: 30px;
  height: auto;
}
/*# sourceMappingURL=login-selection.component-K43C7EHY.css.map */
